///<reference path="../../../../typings/angularjs/angular.d.ts"/>
///<reference path="../../../../typings/angular-ui-bootstrap/angular-ui-bootstrap.d.ts"/>
///<reference path="../services/taskListService.ts"/>

module TaskList {
    export interface IPackageTasks {
        id: string;
        version: number;
        tasks: Array<ITask>;
        assembly: string;
    }

    export interface ITask {
        name: string;
        class: string;
        description: string;
        method: string;
        returnType: string;
        version: string;
    }
    
    export class TaskListController {
        public orderByField: string = "packageId";
        public reverseSort: boolean = false;
        public refreshingUpdatedPackages: boolean = false;
        public packageTasks: Array<IPackageTasks>;
        public packageUpdates: Array<IPackageUpdate>;

        private settingsBase: angular.ui.bootstrap.IModalSettings = {
            controller: "taskImportDialogController as modalCtrl",
            templateUrl: "taskImportTemplate.htm",
        }

        public getImportResultHandlerFunc: ImportResultHandlerFunc = (result, file) => {
            var settings: angular.ui.bootstrap.IModalSettings = {
                resolve: {
                    namespacesAndClasses: () => result,
                    file: () => file,
                    packageId: () => undefined,
                    packageVersion: () => undefined
                }
            }

            this.$modal.open(_.extend(settings, this.settingsBase));
        };

        public hasPackageUpdate(packageId: string, packageVersion: string) {
            return _.some(this.packageUpdates, p => p.packageId.toLowerCase() == packageId.toLowerCase());
        }

        public getUpdatedPackageVersion(packageId) {
            var newPackageVersion = this.packageUpdates[packageId.toLowerCase()].version;
            return newPackageVersion;
        }
        public deletePackage(packageId: string) {
            if (confirm(FRENDS.Localizations.ConfirmTaskDelete)) {
            this.taskService.deletePackage(packageId).then(result => {
                if (!result.data.success) {
                    this.notification.error(result.data.errorMessage);
                } else {
                    this.notification.notify(result.data.data);
                }
                this.updateTasks();
                });
            }
        }

        public updatePackage(packageId: string, packageVersion: string) {
            return this.taskService.updatePackageFromRepository(packageId, packageVersion).then(result => {
                if (!result.data.success) {
                    return;
                }
                var settings: angular.ui.bootstrap.IModalSettings = {
                    resolve: {
                        namespacesAndClasses: () => result.data.data,
                        file: () => undefined,
                        packageId: () => packageId,
                        packageVersion: () => packageVersion
                    }
                };

                this.$modal.open(_.extend(settings, this.settingsBase));
            });
        }

        public changeSort(columnName: string) {
            this.orderByField = columnName;
            this.reverseSort = !this.reverseSort;
        }

        public openSearch() {
            this.$modal.open({
                controller: "taskSearchController",
                controllerAs: "modalCtrl",
                templateUrl: "taskSearch.htm",
                size: "lg",
                resolve: {
                    importHandler: () => (id, version) => this.updatePackage(id, version)
                }
            });
        }

        private refreshUpdatedPackages() {
            this.refreshingUpdatedPackages = true;
            this.taskService.getRefreshedPackageUpdates().then(result => {
                if (result.data.success) {
                    this.packageUpdates = result.data.data;
                }
            }).finally(() => {
                this.refreshingUpdatedPackages = false;
            });
        }

        private updateTasks() {
            this.taskService.getTasks().then(result => {
                if (result.data.success) {
                    this.packageTasks = result.data.data;
                }
            });
        }

        private updatePackageUpdates() {
            this.taskService.getPackageUpdates().then(result => {
                if (result.data.success) {
                    this.packageUpdates = result.data.data;
                }
            });
        }

        constructor(private taskService: TaskListService, private $rootScope: ng.IRootScopeService, private $modal: angular.ui.bootstrap.IModalService, private notification: INotifications) {
            this.updateTasks();
            this.updatePackageUpdates();
            

            $rootScope.$on(taskUpdateEventName, (args) => {
                this.updateTasks();
                this.updatePackageUpdates();
            });
        }
    }

    app.controller("taskListController", ["taskListService", "$rootScope", "$uibModal", "notifications", TaskListController]);
}